<!---------------------------
 ----------------------------
    A list of all products owned by the installer
 ----------------------------
 ---------------------------->

<!-- Show 'no data' message when data is empty -->
@if (hasNoProducts()) {
  <ng-container>
    {{ 'products_emptyList' | translate }}
  </ng-container>
} @else {
  <!-- Show all products -->
  <ng-container>
    <ion-grid class="ion-margin-top">
      @for (product of products(); track product.uid) {
        <ion-row>
          <ion-col
            size="12"
            size-xs="12"
            size-md="12"
            size-lg="12"
            class="ml--3px"
          >
            <ion-grid
              class="product-item app-background ion-no-padding ion-margin-bottom bordered"
            >
              <ion-row>
                <ion-col
                  size="1"
                  class="product-icon center-item text-grey ion-no-padding mt--1px"
                  [ngClass]="
                    product.order && (product.order.id ?? 0) > 0
                      ? product.order.cancelled === null ||
                        product.order.cancelled === undefined
                        ? ''
                        : 'cancelled'
                      : ''
                  "
                >
                  <ion-icon name="basket" class="font-size-24"></ion-icon>
                </ion-col>
                <ion-col size="10" class="ion-no-padding ml--1">
                  <ion-card-header class="ion-no-padding p-1">
                    <div class="text-grey ion-padding-start">
                      <div>
                        <b>
                          {{ product.name | translate }}
                          @if (product.order && (product.order.id ?? 0) > 0) {
                            <ng-container>
                              •
                              @if (product.price ?? 0 > 0) {
                                {{ product.price }}
                              } @else {
                                {{ product.pricePaymentProduct ?? 0 }}
                              }

                              {{ product.unit ?? '' | translate }}
                              @if (product.recurring) {
                                {{ 'products_perYear' | translate }}
                              }
                            </ng-container>
                          }
                        </b>
                      </div>

                      @if (product.order && (product.order.id ?? 0) > 0) {
                        <div>
                          @if (product.recurring) {
                            <ng-container>
                              @if (
                                product.order.cancelled === null ||
                                product.order.cancelled === undefined
                              ) {
                                <ng-container>
                                  {{ 'products_renew' | translate }}
                                  {{
                                    addYear(product.order.added ?? '')
                                      | date: 'MMM d, y'
                                  }}
                                </ng-container>
                              } @else {
                                <ng-template #productCancelled>
                                  {{ 'products_cancelled' | translate }}
                                  {{
                                    addYear(product.order.added ?? '')
                                      | date: 'MMM d, y'
                                  }}
                                </ng-template>
                              }
                            </ng-container>
                          } @else {
                            <ng-template #productAdded>
                              {{ 'products_boughtOn' | translate }}
                              {{ product.order.added | date: 'MMM d, y' }}
                            </ng-template>
                          }
                        </div>
                      } @else {
                        <ng-template #freeProduct>
                          {{ 'products_free' | translate }}
                        </ng-template>
                      }
                    </div>
                  </ion-card-header>
                </ion-col>
                <ion-col class="center-item mr--1">
                  @if (
                    product.order &&
                    (product.order.id ?? 0) > 0 &&
                    product.recurring
                  ) {
                    <ng-container>
                      @if (
                        product.order.cancelled === null ||
                        product.order.cancelled === undefined
                      ) {
                        <ng-container>
                          <ion-label class="ion-text-end">
                            <ion-icon
                              name="caret-down-outline"
                              (click)="presentPopover($event, product.order)"
                              style="padding: 2px"
                              class="border-with-radius"
                            >
                            </ion-icon>
                          </ion-label>
                        </ng-container>
                      }
                    </ng-container>
                  }
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  </ng-container>
}
